export enum CardStatus {
  Draft = 'Draft',
  Approved = 'Approved',
  Archived = 'Archived',
}

export const CardStatuses = Object.values(CardStatus);
